import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import {
  AGENCY_STATUS_OPTION,
  COLOR_AGENCY_STATUS,
  getPlatFormImage,
  LIST_AGENCY_SNS_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatISOString } from "helpers/format";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import CollapseFilter from "components/Common/CollapseFilter";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalPreview from "components/Common/ModalPreview";
import AgencyForm from "./AgencyForm";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import avatar1 from "../../../assets/images/users/ic_defaul_avatar2.png";
import CopyWrapper from "components/Common/CopyWrapper";
import { getAgencyList } from "store/agency/thunk";
import agencyApi from "api/agencyApi";
import ModalPreviewQRCode from "components/Common/ModalPreviewQRCode";
import { truncate } from "utils";
import countriesFormat from "helpers/countries";
import DropdownCountries from "components/Common/DropdownCountries";
import { QRCodeCanvas } from "qrcode.react";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import { useRole } from "components/Hooks/UserHooks";
import { ROUTES } from "routes/allRoutes";
import { push } from "helpers/navigation";
import { getLoggedInUserInfo } from "api/axiosClient";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const AgencyList = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const data = getLoggedInUserInfo();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    page_size: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    name: withDefault(StringParam, ""),
    agency_code: withDefault(StringParam, ""),
    contact_name: withDefault(StringParam, ""),
    contact_phone: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    nationality: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    created_from: withDefault(StringParam, ""),
    created_to: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [previewQRCode, setPreviewQRCode] = useState<any>(null);

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.created_from
      ? moment(query?.created_from || "", "Y-MM-DD").toDate()
      : null,
    query?.created_to
      ? moment(query?.created_to || "", "Y-MM-DD").toDate()
      : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [agencyNameSearch, setAgencyNameSearch] = useState<string>(
    query?.name || ""
  );

  const [agencyCodeSearch, setAgencyCodeSearch] = useState<string>(
    query?.agency_code || ""
  );

  const [contactNameSearch, setContactNameSearch] = useState<string>(
    query?.contact_name || ""
  );

  const [contactPhoneSearch, setContactPhoneSearch] = useState<string>(
    query?.contact_phone || ""
  );

  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");

  const [statusSearch, setStatusSearch] = useState<Option | any>(
    AGENCY_STATUS_OPTION?.find((item) => item?.value === query?.status)
      ?.value || ""
  );

  const [nationalitySearch, setNationalitySearch] = useState<Option | any>("");

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Agency;
  const AgencyProperties = createSelector(selectLayoutState, (state) => ({
    lstAgency: state.lstAgency,
    isAgencyLoading: state.isAgencyLoading,
    isAgencySuccess: state.isAgencySuccess,
    error: state.error,
  }));

  // Inside your component
  const { lstAgency, isAgencyLoading } = useSelector(AgencyProperties);

  function loadTableData() {
    dispatch(getAgencyList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      name: agencyNameSearch,
      agency_code: agencyCodeSearch,
      contact_name: contactNameSearch,
      contact_phone: contactPhoneSearch,
      email: emailSearch,
      nationality: nationalitySearch,
      status: statusSearch,
      created_from: startDate ? formatISOString(startDate, "start") : "",
      created_to: endDate ? formatISOString(endDate, "end") : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        name: "",
        agency_code: "",
        contact_name: "",
        contact_phone: "",
        email: "",
        nationality: "",
        status: "",
        created_from: "",
        created_to: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setAgencyNameSearch("");
    setAgencyCodeSearch("");
    setContactNameSearch("");
    setContactPhoneSearch("");
    setEmailSearch("");
    setNationalitySearch("");
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    status: number | string;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await agencyApi.updateAgency(item?.id, {
        status: item?.status,
      });

      if (response?.statusCode === 200 && response?.message === "Success") {
        dispatch(getAgencyList(query));
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "40px" }}>
              {lstAgency?.pagination?.total -
                ((query?.page - 1) * query?.page_size + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        thWidth: 60,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={cell?.value === 1 ? true : false}
                onChange={(e) => {
                  e?.preventDefault();
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    id: item?.id,
                    status: value === true ? 1 : 0,
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Avatar"),
        accessor: "avatar",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => {
          const photo = cell?.value;
          return (
            <>
              <div className="w-100 text-center " style={{ minWidth: "60px" }}>
                <div
                  style={{ width: "45px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => photo && setLinkImage({ url: photo })}
                >
                  <img
                    src={photo ?? avatar1}
                    className="rounded-circle avatar-sm"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = avatar1;
                    }}
                  />
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: t("Share Link"),
        accessor: "branch_link",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 310,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const branch_link: any = `https://stage8plus.com/?agentCode=${cell?.row?.original?.code}`;

          return branch_link ? (
            <div
              className="d-flex gap-3 align-items-center"
              style={{ maxWidth: "290px" }}
            >
              <div
                className="cursor-pointer"
                onClick={() =>
                  setPreviewQRCode({
                    branch_link: branch_link,
                    title: `${item?.code} - ${item?.name}`,
                  })
                }
              >
                <QRCodeCanvas value={branch_link} size={60} />
              </div>
              <div
                className="cursor-pointer"
                style={{ minWidth: "70px", color: "rgb(0 158 247)" }}
              >
                <CopyWrapper
                  contentCopy={branch_link}
                  style={{ minWidth: "70px" }}
                >
                  {truncate(branch_link, 70)}
                </CopyWrapper>
              </div>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Agency Code"),
        accessor: "code",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          return cell?.value ? (
            <div className="cursor-pointer">
              <CopyWrapper contentCopy={cell?.value}>
                {`${cell?.value}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Agency Name"),
        accessor: "name",
        filterable: false,
        sortable: false,
        thWidth: 180,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return cell?.value ? (
            <div className="cursor-pointer" style={{ minWidth: 150 }}>
              <CopyWrapper contentCopy={cell?.value}>
                {`${cell?.value}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Contact Name"),
        accessor: "contact_name",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return cell?.value ? (
            <div className="cursor-pointer" style={{ minWidth: 100 }}>
              <CopyWrapper contentCopy={cell?.value}>
                {`${cell?.value}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Contact Phone"),
        accessor: "contact_phone",
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return cell?.value ? (
            <div className="cursor-pointer">
              <CopyWrapper contentCopy={cell?.value}>
                {`${cell?.value}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Email"),
        accessor: "email",
        thClass: "whitespace-nowrap",
        thWidth: 80,
        Cell: (cell: any) => {
          return cell?.value ? (
            <div className="cursor-pointer" style={{ minWidth: 60 }}>
              <CopyWrapper contentCopy={cell?.value}>
                {`${cell?.value}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Nationality"),
        accessor: "nationality",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const countryCode = cell?.value;
          const country = countriesFormat.find(
            (item) => item?.code === countryCode
          );

          return countryCode ? (
            <div
              className="d-flex flex-column gap-1"
              style={{ minWidth: "130px" }}
            >
              {
                <div className="cursor-pointer d-flex gap-2 align-items-center ">
                  {country && (
                    <>
                      <img
                        src={country?.flags}
                        width={20}
                        height={20}
                        alt="profile"
                      />
                      <div className="cursor-pointer">
                        {i18n?.language === "ko"
                          ? country?.name_korea
                          : country?.name}
                      </div>
                    </>
                  )}
                </div>
              }
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("SNS Type"),
        accessor: "sns_type",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          let snsType = cell?.row?.original?.sns_type;

          let imgPlatform = getPlatFormImage(snsType);
          return imgPlatform ? (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="snsType"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {
                    LIST_AGENCY_SNS_OPTION?.find(
                      (item) => item?.value === snsType
                    )?.label
                  }
                </div>
              </div>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("SNS URL"),
        accessor: "sns_url",
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return cell?.value ? (
            <div
              className="cursor-pointer text-primary"
              style={{ maxWidth: "220px" }}
            >
              <CopyWrapper
                contentCopy={cell?.value}
                style={{ minWidth: "70px" }}
              >
                {truncate(cell?.value, 70)}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "150px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstAgency?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await agencyApi?.deleteAgency(id);
      if (response?.statusCode === 200 && response?.message === "Success") {
        setItemToDelete(false);
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const onCloseQRCodeClick = () => {
    setPreviewQRCode(null);
  };

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    if (
      data?.user?.role === "agency" &&
      isHavePermissionRole([ROLES_FOR_APP.AGENCY_LIST], userPermissions) ===
        false
    ) {
      push(ROUTES?.AGENCY_PREPAYMENT);
    }
  }, [data]);

  useEffect(() => {
    document.title = `${t("Agency Management")} | Picaverse Agency Star+`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Agency Management")} pageTitle={t("Home")} />
          {isHavePermissionRole(
            [ROLES_FOR_APP.AGENCY_LIST],
            userPermissions
          ) && (
            <Row>
              <Col lg={12}>
                <Card
                  id="customerList"
                  style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                >
                  <CardHeader className="border-0">
                    <div className="d-block d-xl-flex justify-content-between align-items-start">
                      <div
                        className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                        style={{ maxWidth: "100%" }}
                      >
                        <Row className="g-4 align-items-center">
                          <div className="col-sm">
                            <div>
                              <h5 className="card-title mb-0">
                                <span className="me-2">{t("Total")}:</span>
                                <CountUp
                                  start={0}
                                  end={lstAgency?.pagination?.total || 0}
                                  duration={1}
                                  className="text-primary"
                                />
                              </h5>
                            </div>
                          </div>
                        </Row>
                      </div>

                      <div className="col-sm-auto">
                        <button
                          type="button"
                          className="btn btn-success d-none d-md-block"
                          onClick={() => {
                            setIsOpen(true);
                            setItemToEdit(null);
                          }}
                        >
                          <i className="ri-add-fill align-bottom me-1"></i>{" "}
                          {t("Button Create Agency")}
                        </button>
                      </div>
                    </div>
                  </CardHeader>

                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                    <CollapseFilter>
                      <Row className="g-4 align-items-center mt-0 mt-md-2">
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-2"
                        >
                          <LabelWrapper
                            label={`${t("Agency Code")}`}
                            isShow={!!agencyCodeSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Agency Code")}...`}
                              value={agencyCodeSearch}
                              onChange={(e) =>
                                setAgencyCodeSearch(e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-2"
                        >
                          <LabelWrapper
                            label={`${t("Agency Name")}`}
                            isShow={!!agencyNameSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Agency Name")}...`}
                              value={agencyNameSearch}
                              onChange={(e) =>
                                setAgencyNameSearch(e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-2"
                        >
                          <LabelWrapper
                            label={t("Contact Name")}
                            isShow={!!contactNameSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Contact Name")}...`}
                              value={contactNameSearch}
                              onChange={(e) =>
                                setContactNameSearch(e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-2"
                        >
                          <LabelWrapper
                            label={t("Contact Phone")}
                            isShow={!!contactPhoneSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Contact Phone")}...`}
                              value={contactPhoneSearch}
                              onChange={(e) =>
                                setContactPhoneSearch(e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper
                            label={t("Email")}
                            isShow={!!emailSearch}
                          >
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t("Email")}...`}
                              value={emailSearch}
                              onChange={(e) => setEmailSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper label={t("Nationality")} isShow={true}>
                            <DropdownCountries
                              name="nationality"
                              dataList={[]}
                              placeholder={`${t("Select Country")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={nationalitySearch}
                              onChangeSelect={(e: any) => {
                                setNationalitySearch(e?.value);
                              }}
                              isHasOptionAll={true}
                              isAllCountry={true}
                              optionAll={{ label: t("All Filter"), value: "" }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper label={t("Status")} isShow={true}>
                            <DropdownStatusNew
                              name="status"
                              dataList={AGENCY_STATUS_OPTION || []}
                              placeholder={`${t("Select Status")}...`}
                              className="dropdown-status-rounded"
                              classNamePrefix="name-prefix"
                              initialValue={statusSearch}
                              onChangeSelect={(e: any) =>
                                setStatusSearch(e?.value)
                              }
                              isHasOptionAll={true}
                              optionAll={{ label: t("All Filter"), value: "" }}
                              colors={COLOR_AGENCY_STATUS}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                        >
                          <LabelWrapper
                            label={t("Date")}
                            isShow={!!startDate || !!endDate}
                          >
                            <DatePickerCustom
                              startDate={startDate || null}
                              endDate={endDate || null}
                              onChangePicker={handleChangePicker}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col
                          sm={12}
                          md={12}
                          xl={12}
                          xxl={12}
                          className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-3 mt-md-3"
                        >
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-1"
                              onClick={searchData}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t("Button Search")}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t("Button Reset")}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CollapseFilter>
                  </div>
                  <CardBody className="pt-3">
                    <div>
                      <TableContainer
                        className="custom-header-css"
                        divClass="table-responsive table-card"
                        tableClass="align-middle table-bordered-dashed"
                        theadClass="table-light text-muted"
                        columns={columns}
                        data={lstAgency?.items?.length ? lstAgency?.items : []}
                        customPageSize={query.page_size}
                        customPageIndex={query.page - 1}
                        totalRecords={lstAgency?.pagination?.total}
                        customPageCount={Math.ceil(
                          Number(lstAgency?.pagination?.total) /
                            Number(query.page_size)
                        )}
                        handleChangePage={handleChangePage}
                        manualSorting={true}
                        sorting={{
                          sort_by: query.sort_by,
                          order_by: query.order_by,
                        }}
                        handleChangeSorting={handleChangeSorting}
                        isLoading={isAgencyLoading}
                      />
                    </div>
                    <ToastContainer closeButton={false} limit={1} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>

        {isOpen && (
          <AgencyForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            setItemToEdit={setItemToEdit}
            triggerRefresh={triggerRefresh}
            setLinkImage={setLinkImage}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Agency Information")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {previewQRCode && (
          <ModalPreviewQRCode
            data={previewQRCode?.branch_link}
            title={previewQRCode?.title}
            onCloseQRCodeClick={onCloseQRCodeClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default AgencyList;
